/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SettingsIcon from '@material-ui/icons/Settings'

import { Redirect, useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import {
  hasRole,
  renderRoute,
  renderRoutePermissions,
  renderRouteRole,
} from '../../util/utils'

import { fetchAuthenticatedUser } from '../auth/AuthActions'
import { redirectByPermission } from '../main/routes'
import {
  mdiCalendarClock,
  mdiCalendarMultiselectOutline,
  mdiCash100,
  mdiFileDocumentEditOutline,
  mdiFinance,
  mdiMonitorDashboard,
  mdiPackageVariantClosed,
  mdiPhoneClock,
  mdiViewDashboardEditOutline,
  mdiWashingMachine,
} from '@mdi/js'

import ItemMenu from './ListItem'
import Icon from '@mdi/react'
import colors from '../../assets/colors'
import { Divider } from '@material-ui/core'
import { usePermissions } from '../../hooks/usePermission'
import { dashboard, routes } from './MenuRoutes'

function Icons(props) {
  const dispatch = useDispatch()
  const history = useHistory()

  const { hasAnyPermission, canRead, canCreate } = usePermissions()

  const permissions = useSelector(state => state.auth.permissions)
  const permissionUser = useSelector(state => state.auth.permissionUser)

  const configs = useSelector(state => state.auth.laundryConfigs)
  const role = useSelector(state => state.auth.role) || {}
  const userRoles = Array.isArray(role) ? role : [role]

  const keepMenuOpen = useMemo(() => {
    return (
      configs?.find(config => config?.name == 'keep-menu-open')?.is_active ||
      false
    )
  }, [configs])

  useEffect(() => {
    dispatch(fetchAuthenticatedUser())
  }, [])

  const redirection = redirectByPermission(permissions)

  const {
    classes,
    open,
    openRelatory,
    openFinance,
    openCrm,
    openLaundries,
    openCashback,
    openDashboard,
    handleDrawerClose,
    handleDrawerOpen,
    openDrawer,
    handleClick,
    handleClickCrm,
    handleClickOpenLaundries,
    handleClickCashback,
    handleClickRelatory,
    handleClickFinance,
    handleClickDashboard,
  } = props

  const handleCloseMenu = () => {
    if (keepMenuOpen) return null
    return handleDrawerClose()
  }

  function findPerm(roles) {
    return hasAnyPermission(roles, permissionUser)
  }

  useEffect(() => {
    if (!openDrawer && openDashboard) {
      handleClickDashboard()
    }

    if (!openDrawer && openCrm) {
      handleClickCrm()
    }

    if (!openDrawer && openLaundries) {
      handleClickOpenLaundries()
    }

    if (!openDrawer && openCashback) {
      handleClickCashback()
    }

    if (!openDrawer && openFinance) {
      handleClickFinance()
    }

    if (!openDrawer && openRelatory) {
      handleClickRelatory()
    }

    if (!openDrawer && open) {
      handleClick()
    }
  }, [openDrawer])

  const renderRouteChildrens = (childrens = []) => {
    const sorted = childrens.sort((a, b) => a.title.localeCompare(b.title))

    return sorted.map((item, i) => {
      return (
        findPerm(item?.role) && (
          <ItemMenu
            key={i}
            route={item.route}
            handle={handleCloseMenu}
            title={item.title}
            open={openDrawer}
          />
        )
      )
    })
  }

  const menuCollapseStatus = key => {
    const actionByKey = {
      dashboard: openDashboard,
      cadastros: open,
      relatorios: openRelatory,
      'modulo-financeiro': openFinance,
      'modulo-crm': openCrm,
      'modulo-parceiros': openLaundries,
      'modulo-cashback': openCashback,
    }

    return actionByKey[key] || false
  }

  const menuClickActions = key => {
    const actionByKey = {
      dashboard: handleClickDashboard,
      cadastros: handleClick,
      relatorios: handleClickRelatory,
      'modulo-financeiro': handleClickFinance,
      'modulo-crm': handleClickCrm,
      'modulo-parceiros': handleClickOpenLaundries,
      'modulo-cashback': handleClickCashback,
    }

    return actionByKey[key]() || false
  }

  const handleClickMenu = route => {
    const { key = '', childrens = [] } = route
    if (!openDrawer) handleDrawerOpen()
    if (!childrens?.length) return handleCloseMenu()
    if (!key) return null
    return menuClickActions(key)
  }

  const menuIcon = route => {
    const { icon } = route
    return <Icon path={icon} color={colors.primary} size={1.1} />
  }

  const expanded = (route, open) => {
    const { key, childrens } = route

    if (!childrens?.length) return false

    const openedIcon = {
      true: <ExpandLess />,
      false: <ExpandMore />,
    }

    return openedIcon[open]
  }

  return (
    <List className={classes.listDrawer}>
      {redirection}

      {routes?.map(route => {
        const { childrens, key } = route

        const render = childrens?.length
          ? hasAnyPermission(
              childrens?.map(route => route.role).flat(),
              permissionUser
            )
          : canRead(key, permissionUser) || canCreate(key, permissionUser)

        const allowedByRole = route.rolesAllowed?.some(roleName =>
          hasRole(roleName, userRoles)
        )

        if (route.rolesAllowed ? !allowedByRole : !render) return null

        return (
          <React.Fragment key={`menu-route-${route.key}`}>
            <ItemMenu
              route={route?.route || null}
              handle={() => handleClickMenu(route)}
              icon={menuIcon(route)}
              title={route.label}
              expand={expanded(route, menuCollapseStatus(route?.key))}
              open={openDrawer}
            />

            <Collapse
              in={openDrawer && menuCollapseStatus(route?.key)}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {renderRouteChildrens(route?.childrens)}
              </List>
            </Collapse>

            <Divider />
          </React.Fragment>
        )
      })}
    </List>
  )
}

export default React.memo(Icons)
